<template>
  <div class="text-center">
    <v-snackbar
      timeout="-1"
      multi-line
      bottom
      right
      app
      :dark="isDark"
      :light="!isDark"
      :value="dialog"
      class="no-action"
      content-class="pa-0 ma-0"
    >
      <v-card>
        <v-card-title>
          {{ $t('vmail.forceTranscriptionEnableDialog.title') }}
        </v-card-title>

        <v-card-text>
          {{ $t('vmail.forceTranscriptionEnableDialog.text') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="onEnableTranscription()"
          >
            {{ $t('vmail.forceTranscriptionEnableDialog.buttons.enable') }}
          </v-btn>
          <v-btn
            text
            @click="dialog = false"
          >
            {{ $t('vmail.forceTranscriptionEnableDialog.buttons.later') }}
          </v-btn>
          <v-btn
            text
            @click="onPressNever()"
          >
            {{ $t('vmail.forceTranscriptionEnableDialog.buttons.never') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VoicemailLocalStorage from '@/api/voicemail'

export default {
  name: 'voicemails-enable-transcription-snackbar',
  data () {
    return {
      dialog: false,
      initialized: false
    }
  },
  watch: {
    transcriptionEnabled: {
      async handler (newValue) {
        if (this.initialized === false && newValue === false && !this.dismissedDialogForever) {
          this.dialog = true
        }
        if (newValue !== null) {
          this.initialized = true
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      vmbox: 'voicemails/vmboxSettings'
    }),
    transcriptionEnabled () {
      return this.vmbox?.transcript
    },
    dismissedDialogForever () {
      return VoicemailLocalStorage.getDialogDismissedForever()
    },
    transcript: {
      get: function () {
        return this.vmbox.transcript
      },
      set: function (value) {
        if (value !== null && value !== this.vmbox.summarize) {
          this.setTranscript(value)
          this.setSummarize(value)
          this.setCategorize(value)
          this.setTranslate(false)
          this.save()
        }
      }
    },
    isDark () {
      return this.$vuetify.theme.dark
    }
  },
  methods: {
    ...mapActions({
      setTranscript: 'voicemails/setVBTranscript',
      setSummarize: 'voicemails/setVBSummarize',
      setCategorize: 'voicemails/setVBCategorize',
      setTranslate: 'voicemails/setVBTranslate',
      save: 'voicemails/saveSettings'
    }),
    onEnableTranscription () {
      this.transcript = true
      this.dialog = false
    },
    dismissDialogForever (dismiss) {
      VoicemailLocalStorage.setDismissTranscriptionDialog(dismiss)
    },
    onPressNever () {
      this.dialog = false
      this.dismissDialogForever(true)
    }
  }
}
</script>

<style>
  .no-action .v-snack__action {
    margin-right: 0px !important;
  }
</style>
